// extracted by mini-css-extract-plugin
module.exports = {"container__price":"Prices_container__price__1fEAx"};